import { render, staticRenderFns } from "./BlockContent.vue?vue&type=template&id=c36f569c&"
import script from "./BlockContent.vue?vue&type=script&lang=ts&"
export * from "./BlockContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports